const DigitalSignatureProviders = {
    QuoVadis: '1',
    ElectronicSignature: '3',
}
export default DigitalSignatureProviders
